import React, { useState, useEffect, useMemo } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { FormText } from "reactstrap";
import * as Yup from "yup";
import axios from "axios";
import AsyncDropdownSpotify from "../../components/asyncDropdownSpotify";
import AsyncDropdownDeezer from "../../components/asyncDropdownDeezer";
import AsyncDropdownAmazon from "../../components/asyncDropdownAmazon";
import {
  Input,
  Card,
  Row,
  CardBody,
  Col,
  FormGroup,
  Label,
  Button,
  Alert,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap";
import { useFetch } from "../../utils/fetchHook";
import { getCookie } from "../../jwt/_helpers/cookie";
import TableHelper from "../../components/tableHelper";
import { Redirect } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateArtist } from "../../redux/artists/action";
import {
  buildArtistSavePayload,
  spotifyDetailsToSelectOption,
  deezerDetailsToSelectOption,
  amazonDetailsToSelectOption,
} from "../../utils/artistStoreDetails";
import StoreArtistFormImage from "../../components/storeArtistFormImage";

const API_URL = process.env.REACT_APP_API_URL_BASE;
const X_API_KEY = process.env.REACT_APP_X_API_KEY;


const ArtistsUpdate = ({ match, name }) => {
  const dispatch = useDispatch();
  const token = getCookie("token");
  const options = {
    method: "GET",
    mode: 'cors',
    headers: {
      // Authorization: `Bearer ${token}`,
      "x-api-key": X_API_KEY,
      "Content-Type": "application/json"
    }
  };
  const currentID = match.url.split("/")[2];
  const [userData, error, loading] = useFetch(
    "GET",
    `artists/${currentID}/`,
    token
  );

  const [success, setSuccess] = useState(false);
  const [errorPut, setErrorPut] = useState(false);
  const [errorNameMismatch, setErrorNameMismatch] = useState(false);
  const [errorAmazonNameMismatch, setErrorAmazonNameMismatch] = useState(false);
  const [errorDeezerNameMismatch, setErrorDeezerNameMismatch] = useState(false);
  const [errorSpotifyNameMismatch, setErrorSpotifyNameMismatch] = useState(false);
  const [errorProfileUnmatched, setErrorProfileUnmatched] = useState(false);
  const [errorDupl, setErrorDupl] = useState(false);

  const [errorBlacklisted, setErrorBlacklisted] = useState(false);

  const [redirect, setRedirect] = useState(false);

  const [profileMissingModalVisible, setProfileMissingModalVisible] = useState(false);
  const [profileResetModalVisible, setProfileResetModalVisible] = useState(false);

  const [hasSpotifyProfile, setHasSpotifyProfile] = useState(true);
  const [hasDeezerProfile, setHasDeezerProfile] = useState(true);
  const [hasAmazonProfile, setHasAmazonProfile] = useState(true);
  const [hasAppleProfile, setHasAppleProfile] = useState(true);
  const [spotifyArtist, setSpotifyArtist] = useState(null);
  const [deezerArtist, setDeezerArtist] = useState(null);
  const [amazonArtist, setAmazonArtist] = useState(null);
  const [missingStoreName, setMissingStoreName] = useState("");
  const [resetStoreName, setResetStoreName] = useState("");
  const [skipSpotifyPrefill, setSkipSpotifyPrefill] = useState(false);
  const [skipDeezerPrefill, setSkipDeezerPrefill] = useState(false);
  const [skipAmazonPrefill, setSkipAmazonPrefill] = useState(false);
  const [defaultQuery, setDefaultQuery] = useState("");
  const [imageBig, setImageBig] = useState("");
  const [imageSmall, setImageSmall] = useState("");

  const [namePreference, setNamePreference] = useState(null);

  const enabledProfilesCount = [hasSpotifyProfile, hasDeezerProfile, hasAmazonProfile].filter(Boolean).length;
  const selectedArtistsCount = [spotifyArtist, deezerArtist, amazonArtist].filter(Boolean).length;

  const syncArtistName = useMemo(() => {
    const selected = spotifyArtist || deezerArtist || amazonArtist;
    if (!selected) {
      return "";
    }
    return selected.name || selected.label || "";
  }, [spotifyArtist, deezerArtist, amazonArtist]);

  useEffect(() => {
    if(missingStoreName) {
      setProfileMissingModalVisible(true);
    }
  }, [missingStoreName])

  useEffect(() => {
    if(resetStoreName) {
      setProfileResetModalVisible(true);
    }
  }, [resetStoreName])

  useEffect(() => {
    let amazonArtistName = amazonArtist ? amazonArtist.name.toLowerCase() : null;
    let deezerArtistName = deezerArtist ? deezerArtist.name.toLowerCase() : null;
    let spotifyArtistName = spotifyArtist ? spotifyArtist.name.toLowerCase() : null;
    let artistName = userData.name;
    if(artistName) {
      artistName = artistName.toLowerCase();
    }

    const artistNames = [amazonArtistName, deezerArtistName, spotifyArtistName].filter(name => name !== null);
    const allNamesMatch = artistNames.every(name => name === artistNames[0]);

    if (artistNames.length > 0) {
      setErrorNameMismatch(!allNamesMatch);
    }

    if(spotifyArtist && spotifyArtistName !== artistName) {
      setErrorSpotifyNameMismatch(true);
    }

    if(deezerArtist && deezerArtistName !== artistName) {
      setErrorDeezerNameMismatch(true);
    }

    if(amazonArtist && amazonArtistName !== artistName) {
      setErrorAmazonNameMismatch(true);
    }

    if (
      (hasSpotifyProfile && !spotifyArtist) ||
      (hasDeezerProfile && !deezerArtist) ||
      (hasAmazonProfile && !amazonArtist)
    ) {
      setErrorProfileUnmatched(true);
    } else {
      setErrorProfileUnmatched(false);
    }
  }, [amazonArtist, deezerArtist, spotifyArtist, hasSpotifyProfile, hasDeezerProfile, hasAmazonProfile]);
    

  const applySpotifyArtistSelection = (option, setFieldValue) => {
    if (!option) {
      setSpotifyArtist(null);
      if (setFieldValue) {
        setFieldValue("spotifyId", "");
      }
      return;
    }
    const artistObj = { ...option, name: option.label || option.name };
    setSpotifyArtist(artistObj);
    if (setFieldValue) {
      setFieldValue("spotifyId", option.value);
    }
    if (artistObj.image_big) {
      setImageBig(artistObj.image_big);
    }
    if (artistObj.image_small) {
      setImageSmall(artistObj.image_small);
    }
  };

  const applyDeezerArtistSelection = (option, setFieldValue) => {
    if (!option) {
      setDeezerArtist(null);
      if (setFieldValue) {
        setFieldValue("deezerId", "");
      }
      return;
    }
    const artistObj = { ...option, name: option.label || option.name };
    setDeezerArtist(artistObj);
    if (setFieldValue) {
      setFieldValue("deezerId", String(option.value));
    }
    if (!spotifyArtist && !amazonArtist) {
      if (artistObj.image_big) {
        setImageBig(artistObj.image_big);
      }
      if (artistObj.image_small) {
        setImageSmall(artistObj.image_small);
      }
    }
  };

  const applyAmazonArtistSelection = (option, setFieldValue) => {
    if (!option) {
      setAmazonArtist(null);
      if (setFieldValue) {
        setFieldValue("amazonId", "");
      }
      return;
    }
    const artistObj = { ...option, name: option.label || option.name };
    setAmazonArtist(artistObj);
    if (setFieldValue) {
      setFieldValue("amazonId", option.value);
    }
    if (!spotifyArtist && !deezerArtist) {
      if (artistObj.image_big) {
        setImageBig(artistObj.image_big);
      }
      if (artistObj.image_small) {
        setImageSmall(artistObj.image_small);
      }
    }
  };

  useEffect(() => {
    if (!userData || !userData.id) {
      return;
    }
    setImageBig(userData.image_big);
    setImageSmall(userData.image_small);
    setDefaultQuery(userData.name);

    if (userData.spotify_details) {
      setSpotifyArtist(spotifyDetailsToSelectOption(userData.spotify_details, userData));
    } else if (!userData.spotify_identifier) {
      setSpotifyArtist(null);
    }

    if (userData.deezer_details) {
      setDeezerArtist(deezerDetailsToSelectOption(userData.deezer_details));
    }

    if (userData.amazon_music_details) {
      setAmazonArtist(amazonDetailsToSelectOption(userData.amazon_music_details));
    }
  }, [userData])

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    email: Yup.string().email().required("Email is required"),
    spotifyId: Yup.string()
      .matches(
        /^[0-9A-Za-z_-]{22}$/,
        "Please add a valid Spotify ID. Example: 6eUKZXaKkcviH0Ku9w2n3B . Check our Help Center for more info."
      ),
    appleId: hasAppleProfile
      ? Yup.string()
          .required("Apple ID is required")
          .matches(
            /^[0-9]*$/,
            "Please add a valid Apple ID. Example: 635806095 . Check our Help Center for more info."
          )
      : Yup.string().notRequired(),
  });

  return (
    <div>
      {loading ? (
        <TableHelper loading />
      ) : error ? (
        <TableHelper error />
      ) : (
        <>
          <Row>
            <Col sm={12}>
              <Card>
                <CardBody>
                  <h3>Edit Artist</h3>
                  <Formik
                    enableReinitialize
                    initialValues={{
                      name: userData.name || "",
                      email: userData.email || "",
                      spotifyId: userData.spotify_identifier || "",
                      deezerId: userData.deezer_identifier || "",
                      amazonId: userData.amazon_music_identifier || "",
                      appleId: userData.apple_identifier || ""
                    }}
                    validationSchema={validationSchema}
                    onSubmit={(
                        { name, email, spotifyId, appleId, deezerId, amazonId },
                        { setStatus, setSubmitting }
                      ) => {
                        setStatus();
                        setErrorNameMismatch(false);
                        setErrorBlacklisted(false);

                        const options = {
                          method: "PATCH",
                          mode: 'cors',
                          headers: {
                            Authorization: `Bearer ${token}`,
                            "x-api-key": X_API_KEY,
                            "Content-Type": "application/json"
                          }
                        };

                        axios
                        .patch(
                          `${API_URL}artists/${currentID}/`,
                          buildArtistSavePayload({
                            name,
                            email,
                            spotifyId,
                            appleId,
                            deezerId,
                            amazonId,
                            imageBig,
                            imageSmall,
                            followers: spotifyArtist ? spotifyArtist.followers : 0,
                            popularity: spotifyArtist ? spotifyArtist.popularity : 0,
                            spotifyArtist,
                            deezerArtist,
                            amazonArtist,
                            id: currentID,
                          }),
                          options
                        )
                        .then(res => {
                          if (res.data) {
                            dispatch(updateArtist(res.data));
                          }
                          setSuccess(true);
                          setTimeout(() => setRedirect(true), 1000);
                        })
                        .catch(err => {
                          if (err.response && err.response.data) {
                            const errorData = err.response.data;
                            if (errorData.blacklisted && Array.isArray(errorData.blacklisted) && errorData.blacklisted.length > 0) {
                              setErrorBlacklisted(true);
                            } else {
                              setErrorPut(true);
                            }
                          } else {
                            setErrorPut(true);
                          }
                        })
                        .finally(() => setSubmitting(false));
                    }}
                    render={({
                      errors,
                      status,
                      touched,
                      isSubmitting,
                      setFieldValue
                    }) => (
                      <Form>
                        { hasSpotifyProfile &&
                        <>
                          <FormGroup className="select-search-wrap" row>
                            <Label for="Spotify Profile" sm={2}>
                              Spotify Profile
                            </Label>
                            <Col sm={8}>
                              <AsyncDropdownSpotify
                                fetchOptions={options}
                                value={spotifyArtist}
                                defaultQuery={
                                  spotifyArtist
                                    ? ""
                                    : syncArtistName ||
                                      (userData.spotify_identifier ? "" : defaultQuery)
                                }
                                onChange={e => applySpotifyArtistSelection(e, setFieldValue)}
                                placeholder="Enter Artist Name i.e. The Weekend or Artist's Spotify ID i.e. 144HzhpLjcR9k37w5Ico9B"
                              />
                              <FormText color="muted">
                                Note: Only use this dropdown if you want to add an Artist who is already on Spotify otherwise click on Not Found button.
                              </FormText>
                              {
                                errorSpotifyNameMismatch && <p style={{fontSize: "12px",color: "red",margin: "2px 0 0 0"}}>Spotify Profile Name must match with the Artist Name</p>
                              }
                            </Col>
                            <Col sm={2}>
                              {
                                spotifyArtist? 
                                <Button
                                  className="btn btn-outline-info"
                                  style={{width: '100%'}}
                                  onClick={() => {
                                    setResetStoreName("Spotify");
                                  }}
                                >
                                  Reset
                                </Button>:
                                <Button
                                  className="btn btn-outline-danger"
                                  style={{width: '100%'}}
                                  onClick={() => {
                                    if(enabledProfilesCount>=2) {
                                      setMissingStoreName("Spotify");
                                    }
                                  }}
                                >
                                  Not Found?
                                </Button>
                              }
                            </Col>
                          </FormGroup>

                          {
                            spotifyArtist &&
                            <FormGroup row>
                              <Label for="spotifyId" sm={2}>
                                Spotify ID
                              </Label>
                              <Col>
                                <Field
                                  name="spotifyId"
                                  type="text"
                                  disabled={true}
                                  className="form-control"
                                />
                              </Col>
                            </FormGroup>
                          }
                          <StoreArtistFormImage
                            label="Spotify Image"
                            src={spotifyArtist?.image_big}
                            alt="Spotify Artist DP"
                          />
                        </>
                        }

                        { hasDeezerProfile &&
                          <>
                            <FormGroup className="select-search-wrap" row>
                              <Label for="Deezer Profile" sm={2}>
                                Deezer Profile
                              </Label>
                              <Col sm={8}>
                                <AsyncDropdownDeezer
                                  fetchOptions={options}
                                  value={deezerArtist}
                                  defaultQuery={
                                    deezerArtist
                                      ? ""
                                      : syncArtistName ||
                                        (userData.deezer_identifier ? "" : defaultQuery)
                                  }
                                  onChange={e => applyDeezerArtistSelection(e, setFieldValue)}
                                  placeholder="Enter Artist Name i.e. The Weekend or Artist's Deezer ID i.e. 1406580"
                                />
                                <FormText color="muted">
                                  Note: Only use this dropdown if you want to add an Artist who is already on Deezer otherwise click on Not Found button.
                                </FormText>
                                {
                                  errorDeezerNameMismatch && <p style={{fontSize: "12px",color: "red",margin: "2px 0 0 0"}}>Deezer Profile Name must match with the Artist Name</p>
                                }
                              </Col>
                              <Col sm={2}>
                                {
                                  deezerArtist? 
                                  <Button
                                    className="btn btn-outline-info"
                                    style={{width: '100%'}}
                                    onClick={() => {
                                      setResetStoreName("Deezer");
                                    }}
                                  >
                                    Reset
                                  </Button>:
                                  <Button
                                    className="btn btn-outline-danger"
                                    style={{width: '100%'}}
                                    onClick={() => {
                                      if(enabledProfilesCount>=2) {
                                        setMissingStoreName("Deezer");
                                      }
                                    }}
                                  >
                                    Not Found?
                                  </Button>
                                }
                              </Col>
                            </FormGroup>

                            {
                              deezerArtist &&
                              <FormGroup row>
                                <Label for="deezerId" sm={2}>
                                  Deezer ID
                                </Label>
                                <Col>
                                  <Field
                                    name="deezerId"
                                    type="text"
                                    disabled={true}
                                    className="form-control"
                                  />
                                </Col>
                              </FormGroup>
                            }
                            <StoreArtistFormImage
                              label="Deezer Image"
                              src={deezerArtist?.image_big}
                              alt="Deezer Artist DP"
                            />
                          </>
                        }

                        { hasAmazonProfile &&
                          <>
                            <FormGroup className="select-search-wrap" row>
                              <Label for="Amazon Music Profile" sm={2}>
                                Amazon Music Profile
                              </Label>
                              <Col>
                                <AsyncDropdownAmazon
                                  fetchOptions={options}
                                  value={amazonArtist}
                                  defaultQuery={
                                    amazonArtist
                                      ? ""
                                      : syncArtistName ||
                                        (userData.amazon_music_identifier ? "" : defaultQuery)
                                  }
                                  onChange={e => applyAmazonArtistSelection(e, setFieldValue)}
                                  placeholder="Enter Artist Name i.e. The Weekend or Artist's Amazon ASIN i.e. B005GI0T2U"
                                />
                                <FormText color="muted">
                                  Note: Only use this dropdown if you want to add an Artist who is already on Amazon Music otherwise click on Not Found button.
                                </FormText>
                                {
                                  errorAmazonNameMismatch && <p style={{fontSize: "12px",color: "red",margin: "2px 0 0 0"}}>Amazon Profile Name must match with the Artist Name</p>
                                }
                              </Col>
                              <Col sm={2}>
                                {
                                  amazonArtist? 
                                  <Button
                                    className="btn btn-outline-info"
                                    style={{width: '100%'}}
                                    onClick={() => {
                                      setResetStoreName("Amazon Music");
                                    }}
                                  >
                                    Reset
                                  </Button>:
                                  <Button
                                    className="btn btn-outline-danger"
                                    style={{width: '100%'}}
                                    onClick={() => {
                                      if(enabledProfilesCount>=2) {
                                        setMissingStoreName("Amazon Music");
                                      }
                                    }}
                                  >
                                    Not Found?
                                  </Button>
                                }
                              </Col>
                            </FormGroup>

                            {
                              amazonArtist &&
                              <FormGroup row>
                                <Label for="amazonId" sm={2}>
                                  Amazon ID
                                </Label>
                                <Col>
                                  <Field
                                    name="amazonId"
                                    type="text"
                                    disabled={true}
                                    className="form-control"
                                  />
                                </Col>
                              </FormGroup>
                            }
                            <StoreArtistFormImage
                              label="Amazon Music Image"
                              src={amazonArtist?.image_big}
                              alt="Amazon Music Artist DP"
                            />
                          </>
                        }

                        { hasAppleProfile &&
                          <FormGroup row>
                            <Label for="appleId" sm={2}>
                              Apple ID
                            </Label>
                            <Col sm={8}>
                              <Field
                                name="appleId"
                                type="text"
                                placeholder="Please enter a valid Apple ID. Example: 635806095"
                                className={
                                  "form-control" +
                                  (errors.appleId && touched.appleId
                                    ? " is-invalid"
                                    : "")
                                }
                              />
                              <FormText color="muted">
                                Note: Only use this field if you want to add an Artist who is already on Apple Music otherwise click on Not Found button.
                              </FormText>
                              <ErrorMessage
                                name="appleId"
                                component="div"
                                className="invalid-feedback"
                              />
                            </Col>
                            <Col sm={2}>
                                <Button
                                  className="btn btn-outline-danger"
                                  style={{width: '100%'}}
                                  onClick={() => {
                                    setMissingStoreName("Apple Music");
                                  }}
                                >
                                  Not Found?
                                </Button>
                            </Col>
                          </FormGroup>
                        }

                        <FormGroup row>
                          <Label for="name" sm={2}>
                            Name
                          </Label>
                          <Col>
                            <Field
                              name="name"
                              type="text"
                              disabled={true}
                              className={
                                "form-control" +
                                ((errorNameMismatch || errors.name)  && touched.name ? " is-invalid" : "")
                              }
                            />
                            {
                              errorDupl && <p style={{fontSize: "12px",color: "red",margin: "2px 0 0 0"}}>Artist already exists</p>
                            }
                            {
                              errorNameMismatch && <p style={{fontSize: "12px",color: "red",margin: "2px 0 0 0"}}>Artist name must match for all stores</p>
                            }
                          </Col>
                        </FormGroup>
                        
                        { (selectedArtistsCount>1 && !(errorSpotifyNameMismatch || errorDeezerNameMismatch || errorAmazonNameMismatch)) &&
                          <FormGroup row>
                            <Label for="Name Preference" sm={2}>
                              Name Preference
                            </Label>
                            <Col>
                              <div style={{ display: "flex", justifyContent: "normal" }} >
                                {
                                  spotifyArtist &&
                                  <FormGroup check className="mr-4">
                                    <Label check>
                                      <Input
                                        type="radio"
                                        name="prefer-spotify"
                                        value="spotify"
                                        checked={namePreference === "spotify"}
                                        onChange={() => {
                                          setNamePreference("spotify")
                                          setFieldValue("name", spotifyArtist.name);
                                        }}
                                      />{" "}
                                      <span className="mt-1">Spotify</span>
                                    </Label>
                                  </FormGroup>
                                }

                                {
                                  deezerArtist &&
                                  <FormGroup check className="mr-4">
                                    <Label check>
                                      <Input
                                        type="radio"
                                        name="prefer-deezer"
                                        value="spotify"
                                        checked={namePreference === "deezer"}
                                        onChange={() => {
                                          setNamePreference("deezer")
                                          setFieldValue("name", deezerArtist.name);
                                        }}
                                      />{" "}
                                      <span className="mt-1">Deezer</span>
                                    </Label>
                                  </FormGroup>
                                }

                                {
                                  amazonArtist &&
                                  <FormGroup check className="mr-4">
                                    <Label check>
                                      <Input
                                        type="radio"
                                        name="prefer-amazon"
                                        value="amazon"
                                        checked={namePreference === "amazon"}
                                        onChange={() => {
                                          setNamePreference("amazon")
                                          setFieldValue("name", amazonArtist.name);
                                        }}
                                      />{" "}
                                      <span className="mt-1">Amazon Music</span>
                                    </Label>
                                  </FormGroup>

                                }

                              </div>
                            </Col>
                          </FormGroup>
                        }

                        <FormGroup row>
                          <Label for="email" sm={2}>
                            Email
                          </Label>
                          <Col>
                            <Field
                              name="email"
                              type="text"
                              className={
                                "form-control" +
                                (errors.email && touched.email
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="email"
                              component="div"
                              className="invalid-feedback"
                            />
                          </Col>
                        </FormGroup>

                        <FormGroup row>
                          <Col>
                            <Button color="success" disabled={errorDupl || errorNameMismatch || errorProfileUnmatched || errorBlacklisted} type="submit">
                              Submit
                            </Button>
                          </Col>
                        </FormGroup>

                        <Modal isOpen={profileMissingModalVisible} centered={true}>
                          <ModalHeader>
                            Profile Not Present Declaration
                          </ModalHeader>
                          <ModalBody>
                            I confirm that this Artist's profile is not present on <strong>{missingStoreName}</strong> and that the profile of this Artist be created freshly on <strong>{missingStoreName}</strong>.
                          </ModalBody>
                          <ModalFooter>
                            <Button
                              color="secondary"
                              onClick={() => {
                                setProfileMissingModalVisible(false);
                                setMissingStoreName("Spotify");
                              }}
                            >
                              Cancel
                            </Button>
                            <Button
                              color="success"
                              onClick={() => {
                                if(missingStoreName === "Spotify") {
                                  setHasSpotifyProfile(false);
                                  setSpotifyArtist(null);
                                  setFieldValue("spotifyId", "");
                                }
                                if(missingStoreName === "Deezer") {
                                  setHasDeezerProfile(false);
                                  setDeezerArtist(null);
                                  setFieldValue("deezerId", "");
                                }
                                if(missingStoreName === "Amazon Music") {
                                  setHasAmazonProfile(false);
                                  setAmazonArtist(null);
                                  setFieldValue("amazonId", "");
                                }
                                if(missingStoreName === "Apple Music") {
                                  setHasAppleProfile(false);
                                  setFieldValue("appleId", "");
                                }
                                setProfileMissingModalVisible(false);
                                setMissingStoreName("");
                              }}
                            >
                              Confirm
                            </Button>
                          </ModalFooter>
                        </Modal>

                        <Modal isOpen={profileResetModalVisible} centered={true}>
                          <ModalHeader>
                            Profile Reset Declaration
                          </ModalHeader>
                          <ModalBody>
                            I am aware that by resetting this Artist's <strong>{resetStoreName}</strong> profile will remove the <strong>{resetStoreName} ID</strong> from everywhere in the system and by doing so, it is likely to cause disruptions in the stores and artists to mismatch.
                          </ModalBody>
                          <ModalFooter>
                            <Button
                              color="secondary"
                              onClick={() => {
                                setProfileResetModalVisible(false);
                                setResetStoreName("");
                              }}
                            >
                              Cancel
                            </Button>
                            <Button
                              color="success"
                              onClick={() => {
                                if(resetStoreName === "Spotify") {
                                  setSkipSpotifyPrefill(true);
                                  setSpotifyArtist(null);
                                  setErrorNameMismatch(false);
                                  setErrorSpotifyNameMismatch(false);
                                  setErrorDupl(false);
                                  setErrorBlacklisted(false);
                                  setFieldValue("spotifyId", "");
                                  if(!deezerArtist && !amazonArtist) {
                                    setImageBig("");
                                    setImageSmall("");
                                  } else if(namePreference === "spotify") {
                                    if(deezerArtist) {
                                      setNamePreference("deezer");
                                      setImageBig(deezerArtist.image_big);
                                      setImageSmall(deezerArtist.image_small);
                                    } else if (amazonArtist) {
                                      setNamePreference("amazon");
                                      setImageBig(amazonArtist.image_big);
                                      setImageSmall(amazonArtist.image_small);
                                    }
                                  }
                                }
                                if(resetStoreName === "Deezer") {
                                  setSkipDeezerPrefill(true);
                                  setDeezerArtist(null);
                                  setErrorNameMismatch(false);
                                  setErrorDeezerNameMismatch(false);
                                  setErrorDupl(false);
                                  setErrorBlacklisted(false);
                                  setFieldValue("deezerId", "");
                                  if(!spotifyArtist && !amazonArtist) {
                                    setImageBig("");
                                    setImageSmall("");
                                  } else if(namePreference === "deezer") {
                                    if(spotifyArtist) {
                                      setNamePreference("spotify");
                                      setImageBig(spotifyArtist.image_big);
                                      setImageSmall(spotifyArtist.image_small);
                                    } else if (amazonArtist) {
                                      setNamePreference("amazon");
                                      setImageBig(amazonArtist.image_big);
                                      setImageSmall(amazonArtist.image_small);
                                    }
                                  }
                                }
                                if(resetStoreName === "Amazon Music") {
                                  setSkipAmazonPrefill(true);
                                  setAmazonArtist(null);
                                  setErrorNameMismatch(false);
                                  setErrorAmazonNameMismatch(false);
                                  setErrorDupl(false);
                                  setErrorBlacklisted(false);
                                  setFieldValue("amazonId", "");
                                  if(!spotifyArtist && !deezerArtist) {
                                    setImageBig("");
                                    setImageSmall("");
                                  } else if(namePreference === "amazon") {
                                    if(spotifyArtist) {
                                      setNamePreference("spotify");
                                      setImageBig(spotifyArtist.image_big);
                                      setImageSmall(spotifyArtist.image_small);
                                    } else if (deezerArtist) {
                                      setNamePreference("deezer");
                                      setImageBig(deezerArtist.image_big);
                                      setImageSmall(deezerArtist.image_small);
                                    }
                                  }
                                }
                                setProfileResetModalVisible(false);
                                setResetStoreName("");
                              }}
                            >
                              Confirm
                            </Button>
                          </ModalFooter>
                        </Modal>
                      </Form>
                    )}
                  />
                  {success && (
                    <Alert color="success">
                      Artist of name "{userData.name}" has been updated!
                    </Alert>
                  )}
                  {redirect ? <Redirect to="/artists" /> : null}
                  {errorPut && (
                    <Alert color="danger">
                      Something went wrong! Please refresh page and try again!
                    </Alert>
                  )}
                  {
                    errorBlacklisted && (
                      <Alert color="danger">
                        One or more of the details that you have provided are related to an artist that is blacklisted. If you are sure that the artist is not blacklisted, please contact the support team for further information.
                      </Alert>
                    )
                  }
                </CardBody>
              </Card>
            </Col>
          </Row>
        </>
      )}
    </div>
  );
};

export default ArtistsUpdate;
